import fs from '@/services/fs'
import JSZip from 'jszip'

import { fetchProgress, readFileAsText } from '../utils/utils'

export default {
  async downloadHpub(bookId, url, options) {
    let hasError = false
    let response = await fetch(url)

    if (response.body) {
      fetchProgress(response.clone(), options.progressUpdate)
    }

    if (response.blob) {
      response = await response.blob()
    }

    const unzipFiles = await JSZip.loadAsync(response)
    options.newStatus('PROCESSING')

    await Promise.all(Object.keys(unzipFiles.files).map(async (relativePath, zipEntry) => {
      const file = await unzipFiles.file(relativePath)
      let fileBlob = file ? await file.async('blob') : undefined

      try {
        // append base tag in html to incept them in SW
        if (fileBlob && relativePath.endsWith('html')) {
          // Read blob as text
          let content = await readFileAsText(fileBlob)
          // find @import url and replace them with <link>
          // replace js script source as well
          content = content
            .replace(/<style.*>@import url\('(?!\/.*$)([A-Z0-9a-z.-_/]+)'\);<\/style>/igm, `<link rel="stylesheet" type="text/css" href="/${bookId}/$1">`)
            .replace(/(href|src)="(?!\/.*$)([A-Z0-9a-z.-_/]+).(css|js)"/igm, `$1="/${bookId}/$2.$3"`)
          const parser = new DOMParser()
          const base = document.createElement('base')
          // parse HTML string
          let htmlDoc = parser.parseFromString(content, 'text/html')
          // Alter base href
          base.href = `/${bookId}/`
          // Append base tag to head
          htmlDoc.head.appendChild(base)
          // Create blob back
          fileBlob = new Blob([new XMLSerializer().serializeToString(htmlDoc)], {type: 'text/html'})
        }

        if (fileBlob && relativePath.endsWith('css')) {
          // css had wrong mime type, which causes IE Edge issues
          fileBlob = fileBlob.slice(0, fileBlob.size, 'text/css')
        }
      } catch(e) {
        // Can't break .map method, so we need to set error flag
        hasError = true
        throw new Error(e)
      }

      // Write file into IDB
      if (fileBlob && !hasError) {
        // Dexie has problem with concurrent async inside transaction
        // bulkFile should be fixed
        await fs.outputFile(`/books/${bookId}/${relativePath}`, fileBlob)
      }
    }))

    return true
  }
}
